import {
	ADMINCREATEFEEMAPPING_SUCCESS,
	ADMINCREATEFEEMAPPING_FAILED,
	RESET_ADMINCREATEFEEMAPPING,
	LOADING_ADMINCREATEFEEMAPPING,
	NETWORK_ERROR_ADMINCREATEFEEMAPPING
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINCREATEFEEMAPPING:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {}
			};
		case ADMINCREATEFEEMAPPING_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload
			};
		case ADMINCREATEFEEMAPPING_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload
			};
		case NETWORK_ERROR_ADMINCREATEFEEMAPPING:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {}
			};
		case RESET_ADMINCREATEFEEMAPPING:
			return (state = initialState);
		default:
			return state;
	}
};
